import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';

//write code to add a second image to the about page  




import css from './AboutPage.module.css';
import image from './aboutPage.jpg';


const AboutPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  return (
    <LayoutSingleColumn>
      <LayoutWrapperTopbar>
        <TopbarContainer />
      </LayoutWrapperTopbar>

      <LayoutWrapperMain className={css.staticPageWrapper}>
        <div className={css.pageContent}>
          <h1 className={css.pageTitle}>About aVet</h1>
          <img className={css.coverImage} src={image} alt="My first ice cream." />

          <div className={css.contentWrapper}>
            <div className={css.contentMain}>
              <h2 className={css.heading}>
                Welcome to aVet - Connecting Vets and Pet Owners!
              </h2>

              <p>
                aVet was founded with a mission to provide a seamless platform for independent veterinarians to connect with their patients and pet owners. Whether you need a trusted vet for your furry friend or want to manage your pet's health records, aVet has got you covered!
              </p>

              <h3 className={css.subtitle}>Why Choose aVet?</h3>

              <p>
                Our platform offers a one-stop solution for all your pet healthcare needs. Here's why aVet stands out:
              </p>

              <ul className={css.featureList}>
                <li>Book Appointments Online: Easily schedule appointments with your preferred veterinarian.</li>
                <li>Access Health Records: Keep track of your pet's health records securely in one place.</li>
                <li>Virtual Consultations: Connect with vets through video calls for convenient consultations.</li>
                <li>Quick &amp; Easy Payments: Seamless payment options for hassle-free transactions.</li>
              </ul>

              <h3 id="contact" className={css.subtitle}>Get in Touch</h3>

              <p>
                Have questions or need assistance? We're here to help!
              </p>
              <p>
                Reach out to us via email at <a href="mailto:support@find-avet.com">support@find-avet.com</a> or use our contact form.
              </p>
              <p>
                Follow us on{' '}
                <ExternalLink href={siteFacebookPage}>Facebook</ExternalLink> and{' '}
                <ExternalLink href={siteTwitterPage}>Twitter</ExternalLink> for updates.
              </p>
              <p>
                Are you a veterinarian?{' '}
                <ExternalLink href={siteTwitterPage}>Sign up here</ExternalLink> to join our network.
              </p>
            </div>
          </div>
        </div>
      </LayoutWrapperMain>

      <LayoutWrapperFooter>
        <Footer />
      </LayoutWrapperFooter>
    </LayoutSingleColumn>
  );
};

export default AboutPage;


